import React from 'react';
import { Edit, useEditContext, useTranslate } from 'react-admin';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import AffectationForm from './detail/AffectationForm';
import EditActions from './detail/EditActions';

const Title = () => {
  const { record, isPending } = useEditContext();
  const translate = useTranslate();
  const name =
    !isPending && record
      ? record.account_name || record.cleaner_fullname
      : null;
  const action = translate('app.page_title.edit');
  useDocumentTitle(name ? `${name} - ${action}` : action);

  return null;
};

export default (props) => {
  return (
    <Edit
      {...props}
      redirect="show"
      actions={<EditActions />}
      title={<Title />}
    >
      <AffectationForm />
    </Edit>
  );
};
